import { css } from "@emotion/react";
import { Button, Theme, useTheme } from "@mui/material";
import { FC, useCallback, useState } from "react";

import CreateAccountLead from "~/components/common/CreateAccountLead";
import AnswerForm from "~/components/database/detail/response-modal-content/response-form/AnswerForm";
import {
  Props,
  updateResponseAnswer,
} from "~/components/database/detail/response-modal-content/response-form/lib";
import { fixedWidth } from "~/lib/client/design";
import { useAppContext } from "~/pages/_app";

const PcResponseForm: FC<Props> = ({
  form,
  stepToConfirm,
  setResponseAnswers,
  responseAnswers,
}) => {
  const { currentUser } = useAppContext();
  const theme = useTheme();

  // 各投稿への入力の結果
  // TODO: 戻ってきたときに、初期化が全て false なのでバグっている。治すべき。 author: @funwarioisii
  const [validationResults, setValidationResults] = useState<boolean[]>(
    form.questions.map(() => false)
  );

  // 与えられた position ごとに validation の結果を更新できるようにする
  // FIXME: `updateResponseAnswer` と position なのか quest id なのかで一貫性が保てておらず、ややわかりづらいから治したい author: @funwarioisii
  const updateValidationResult = useCallback(
    (position: number) => (isValid: boolean) =>
      setValidationResults((prev) =>
        prev.map((validationResult, index) =>
          index === position ? isValid : validationResult
        )
      ),
    [setValidationResults]
  );

  if (currentUser === undefined) return null;

  if (currentUser === null) {
    return (
      <div css={rootStyle(theme)}>
        <div css={createAccountLeadContainerStyle}>
          <CreateAccountLead
            label={"データベースに書き込むにはログインが必要です。"}
          />
        </div>
      </div>
    );
  }

  return (
    <div css={rootStyle(theme)}>
      <div css={titleAndDescriptionStyle}>
        <p css={formTitleStyle(theme)}>{form.title}</p>
        <p css={formDescriptionStyle(theme)}>{form.description}</p>
      </div>
      <div css={answerFormsContainerStyle}>
        {form.questions.map((question) => {
          const responseAnswerInput = responseAnswers.find(
            (responseAnswer) => responseAnswer.questionId === question.id
          );
          if (!responseAnswerInput) {
            return null;
          }
          return (
            <AnswerForm
              key={question.id}
              question={question}
              updateResponseAnswer={updateResponseAnswer(
                question.id,
                setResponseAnswers
              )}
              setIsValid={updateValidationResult(question.position)}
              responseAnswerInput={responseAnswerInput}
            />
          );
        })}
      </div>
      <div css={buttonContainerStyle}>
        <Button
          onClick={stepToConfirm}
          disabled={
            !validationResults.every((validationResult) => validationResult)
          }
          variant="contained"
          style={{
            margin: "0.5rem",
          }}
          color={"primary"}
        >
          確認する
        </Button>
      </div>
    </div>
  );
};

const rootStyle = (theme: Theme) => css`
  ${fixedWidth("40rem")}
  background-color: ${theme.palette.background.default};
`;

const createAccountLeadContainerStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const formTitleStyle = (theme: Theme) => css`
  ${fixedWidth("16rem")}
  font-size: 1.5rem;
  font-weight: 700;
  color: ${theme.palette.text.primary};
  border-right: 1px solid #ccc;
  padding-left: 1rem;
  padding-right: 1rem;

  display: flex;
  align-items: center;
`;

const formDescriptionStyle = (theme: Theme) => css`
  ${fixedWidth("24rem")}
  font-size: 1rem;
  color: ${theme.palette.text.primary};
  padding: 3rem 1rem;

  white-space: pre-wrap;
  word-wrap: break-word;
`;

const titleAndDescriptionStyle = css`
  display: flex;
  ${fixedWidth("40rem")}
  flex-direction: row;
  border-bottom: 1px solid #ccc;

  p {
    margin: 0;
  }
`;

const answerFormsContainerStyle = css`
  ${fixedWidth("40rem")}
`;

const buttonContainerStyle = css`
  display: flex;
  justify-content: flex-end;
  margin-right: 1rem;
`;

export default PcResponseForm;
